import "./styles.scss";

import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function Contracts({ setShowTaxInformation = false }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const isManager = user?.role === "companyManager" || user?.role === "customerService";

  if (affiliateInfo?.affiliateTaxInformations?.length === 0) return <div />;

  return (
    <div className="containerContracts">
      <h2 className="title">{!isManager ? t("CONTRACTS") : ""}</h2>

      <div className="cardContent">
        <table>
          <thead>
            <tr>
              <th>{t("CONTRACTS")}</th>
              <th>{t("SIGNATURE_DATE")}</th>
              <th>{t("OPTIONS")}</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="center">{t("BE_AFFILIATED")}</td>
              <td className="center">
                {affiliateInfo?.affiliateTaxInformations[0]?.wdocSignedAt
                  ? moment(affiliateInfo?.affiliateTaxInformations[0]?.wdocSignedAt).format(t("DATE_FORMAT"))
                  : "--/--/----"}
              </td>
              <td className="center">
                {affiliateInfo?.affiliateTaxInformations[0]?.wdocSignStatus === "signed" ? (
                  <>
                    <button className="button" onClick={() => setShowTaxInformation(true)}>
                      {t("UPDATE_SCREEN")}
                    </button>
                    <button
                      className="button btn-blue"
                      onClick={() => window.open(affiliateInfo?.affiliateTaxInformations[0]?.wdocLink, "_blank")}
                    >
                      {t("VIEW_CONTRACT")}
                    </button>
                  </>
                ) : (
                  <p>{t("SIGNATURE_PENDING")}</p>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Contracts;
